import { CanDeactivateFn } from '@angular/router';
import { NavigationGuardComponent } from '@ra-state';
import { Observable } from 'rxjs';

/**
 * Functional guard to check for pending changes before navigating away
 */
export function genCanDeactivateFn<T extends NavigationGuardComponent>(
  isComponentDirty: (component: T) => boolean,
): CanDeactivateFn<T> {
  // eslint-disable-next-line  sonarjs/function-return-type
  const pendingChangesGuard: CanDeactivateFn<T> = (component: T): Observable<boolean> | Promise<boolean> | boolean => {
    if (isComponentDirty(component)) {
      // Return the observable from the dialog
      return component.confirmNavigation$();
    }
    return true;
  };
  return pendingChangesGuard;
}
